//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class="mainlayout">

    <div class="top-panel">
      <div class="top-panel-logo-panel">
        <div class="top-panel-logo-panel-icon"><i class="fas fa-star"></i></div>
        <div class="top-panel-logo-panel-text">{{appSettings.appName}}</div>
        <div class="top-panel-logo-panel-cover" @click="logoOnClick()"></div>
      </div>
      <div style2="position:absolute; top:8px; right:12px;">
         <top-menu></top-menu>
      </div>
    </div>
    <div class="content">
      <keep-alive>
        <router-view style="width:100%; height:calc(100vh - 50px); background:#fff;"></router-view>
      </keep-alive>
    </div>

  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

// import http from 'axios'

import realtimeServerDataManager from '@/technical/realtimeServerDataManager'
// import mainCommonDataLoader from './mainCommonDataLoader'
// import serverErrorHandling from '@/technical/serverErrorHandling'

import serverData from '@/store/serverData'

import Vue from 'vue'
import VueSailsIO from 'vue-sails.io'

import TopMenu from './TopMenu.vue'

export default {
  components: {TopMenu},
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'i18n',
      'activeUser',
      'mainMenuType',
      'commonData' // for realtimeServerDataManager
    ])
  },
  created: function () {
    // var thisRef = this

    // преобразуем http://localhost:1777/api/ в http://localhost:1777 чтобы sails socket достучался
    // пустым второй параметр нельзя оставлять тогда ошибка в console выдется
    // Vue.use(VueSailsIO, 'http://no_url') // !!!!!!!!!!!!!!!!?????????????? Вроде он должен пробовать логинится по этому адресу но на практике логинится уже по нормальному
    var serverUrl = this.appSettings.server.host
    Vue.use(VueSailsIO, serverUrl.substr(0, serverUrl.substr(0, serverUrl.lastIndexOf('/')).lastIndexOf('/')) + '/')
    this.$sails.sails.reconnection = true // устанавливаем глобальный флаг реконнектится в случае если сокет раздисконнетится
    /*
    realtimeServerDataManager(this.$sails, this.appSettings, function () {
      mainCommonDataLoader({all: true}, function (error) {
        if (error) return serverErrorHandling(error, thisRef)
        else thisRef.commonDataIsLoadedSet(true)
      })
    })
    */
    realtimeServerDataManager(this, function () {
      // thisRef.mainMenuInstance.makeMainMenu()
    })
  },
  methods: {
    logoOnClick () {
      if (this.$router.app._route.path === '/') serverData.eventsBus.$emit('eventsTimelineSetScrollToTop')
      this.$router.push('/')
    },
    ...mapMutations([
      'mainMenuTypeSet',
      'activeUserSet',
      'commonDataIsLoadedSet'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
@import "./MainLayout.css";
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainLayout.vue?735c4d50